import React from 'react';
import classNames from 'classnames';

import Loading from '../../../components/Loading';
import TitleBlock from '../../../components/TitleBlock/TitleBlock';
import BackBreadcrumbActions from '../../../components/BackBreadcrumbActions/BackBreadcrumbActions';

const ConfigureDetailPageLayout = ({
    name,
    is_shared = false,
    description,
    isLoading,
    backLinkHref,
    breadcrumbs,
    renderMoreOptions,
    truncateDescription = false,
    children,
}) => {
    const descriptionClassName = classNames(
        'font-body text-body-regular-s text-neutral-400 whitespace-pre-wrap',
        truncateDescription && 'line-clamp-1'
    );

    return (
        <div className="page-position overflow-y-auto pb-2 bg-neutral-50">
            {!isLoading && (
                <>
                    <BackBreadcrumbActions
                        backLinkHref={backLinkHref}
                        breadcrumbs={breadcrumbs}
                        renderMoreOptions={renderMoreOptions}
                    />

                    <div className="w-full flex flex-col gap-5 p-5 sm:p-8">
                        <div className="max-w-[800px] flex flex-col gap-1">
                            <TitleBlock title={name} withSharedIcon={is_shared} />

                            <p className={descriptionClassName}>{description}</p>
                        </div>

                        {children}
                    </div>
                </>
            )}

            {isLoading && (
                <div className="w-full h-full flex items-center justify-center">
                    <Loading />
                </div>
            )}
        </div>
    );
};

export default ConfigureDetailPageLayout;
